import { useState } from 'react';
import { faqList } from '@/mocks/manga';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            关于韩漫之家的使用，这里有您想知道的答案
          </p>
        </div>

        <div className="space-y-3">
          {faqList.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <span className={`w-6 h-6 flex items-center justify-center shrink-0 transition-transform duration-300 ${
                  openIndex === index ? 'rotate-180 text-primary-500' : 'text-foreground-400'
                }`}>
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}